import React, { useState } from 'react'
import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

type Props = {
  requestId?: string
}

export const RequestIdDisplay: React.FC<Props> = ({ requestId }) => {
  const [copySuccess, setCopySuccess] = useState(false)

  const handleCopy = async () => {
    if (!requestId) return

    try {
      await navigator.clipboard.writeText(requestId)
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), 2000)
    } catch (err) {
      console.error('コピーに失敗しました:', err)
    }
  }

  if (!requestId) {
    return null
  }

  return (
    <Box
      sx={{
        mb: 1,
        p: 1,
        backgroundColor: 'grey.100',
        borderRadius: 1,
        fontSize: '0.75rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        color: 'text.secondary',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Request ID: {requestId}
      </Typography>
      <Tooltip title={copySuccess ? 'コピーしました！' : 'IDをコピー'}>
        <IconButton
          size="small"
          onClick={handleCopy}
          sx={{
            color: 'text.secondary',
            p: 0.5,
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
